import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
// 时间转换方法,_time[传入时间戳] , _timeFull[传入时间全格式]
Vue.prototype.timeTurn = function(_time, _timeFull) {

	var date = null;

	if (_timeFull == undefined || _timeFull == null) {
		if ((_time.toString()).length == 10) {
			_time += "000"
		}
		date = new Date(Number(_time));
	} else {

		date = new Date(_timeFull)
	}



	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();
	var hour = date.getHours();
	var minute = date.getMinutes();
	var second = date.getSeconds();

	//  return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second; 
	return year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' + (String(day).length > 1 ? day :
		'0' +
		day) + ' ' + (String(hour).length > 1 ? hour : '0' + hour) + ':' + (String(minute).length > 1 ? minute :
		'0' +
		minute) + ':' + (String(second).length > 1 ? second : '0' + second)

	// return new Date(parseInt(time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');   
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
